import { fetchRemoteBranchCashSummary } from '../../reports/infra/reportsRemoteRepo';
import { cashSummaryTodayStartIso } from './cashSummaryRemoteCache';
import { healCashSessionAlreadyOpenConflicts } from '../../sync/core/repair/healCashSessionAlreadyOpen';
import { bumpCashSessionChangeSignal } from './cashSessionChangeSignal';

/**
 * Adopta el turno open remoto tras cash_session_already_open.
 * ADR-017: sin espejo SQLite — solo heal + señal UI.
 */
export async function adoptRemoteOpenAfterAlreadyOpen(
  ghostSessionId: string,
  branchId: string
): Promise<string> {
  void ghostSessionId;
  await healCashSessionAlreadyOpenConflicts();

  const remote = await fetchRemoteBranchCashSummary(branchId, cashSummaryTodayStartIso(), { force: true });
  const remoteSession = remote?.activeSession;
  if (remoteSession?.status === 'open') {
    bumpCashSessionChangeSignal();
    return remoteSession.id;
  }

  throw new Error(
    'Ya hay una caja abierta en esta sucursal (otro equipo). Actualizá la pantalla para ver el turno.'
  );
}

/** Si el servidor rechazó la apertura (caja ya abierta), adopta el remoto. */
export async function reconcileCashOpenAfterRemoteConflict(
  sessionId: string,
  branchId: string,
  options?: { knownAlreadyOpen?: boolean }
): Promise<string | null> {
  if (!options?.knownAlreadyOpen) {
    return null;
  }

  return adoptRemoteOpenAfterAlreadyOpen(sessionId, branchId);
}

